var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65996 3.75H13.34L14.7816 2.59667C15.2725 2.205 15.4558 1.56917 15.2483 0.975833C15.0408 0.3825 14.5016 0 13.875 0H6.12496C5.49829 0 4.95913 0.383333 4.75163 0.975833C4.54413 1.56833 4.72746 2.205 5.21746 2.59583L6.65996 3.75Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4542 5H6.54583C4.27 7.23417 2.5 11.1542 2.5 14.375C2.5 17.1742 3.98167 20 7.29167 20H12.9167C15.7442 20 17.5 17.8442 17.5 14.375C17.5 11.1542 15.73 7.23417 13.4542 5ZM9.68333 11.875H10.3167C11.2908 11.875 12.0833 12.6675 12.0833 13.6417C12.0833 14.5175 11.4517 15.2383 10.625 15.385V16.0408C10.625 16.3858 10.345 16.6658 10 16.6658C9.655 16.6658 9.375 16.3858 9.375 16.0408V15.4167H8.54167C8.19667 15.4167 7.91667 15.1367 7.91667 14.7917C7.91667 14.4467 8.19667 14.1667 8.54167 14.1667H10.3167C10.6017 14.1667 10.8333 13.935 10.8333 13.65C10.8333 13.3567 10.6017 13.125 10.3167 13.125H9.68333C8.70917 13.125 7.91667 12.3325 7.91667 11.3583C7.91667 10.4825 8.54833 9.76167 9.375 9.615V8.95833C9.375 8.61333 9.655 8.33333 10 8.33333C10.345 8.33333 10.625 8.61333 10.625 8.95833V9.58333H11.4583C11.8033 9.58333 12.0833 9.86333 12.0833 10.2083C12.0833 10.5533 11.8033 10.8333 11.4583 10.8333H9.68333C9.39833 10.8333 9.16667 11.065 9.16667 11.35C9.16667 11.6433 9.39833 11.875 9.68333 11.875Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.5f572fab3f43f6947d1b5750535112b3.svg";
export { ForwardRef as ReactComponent };